import React from 'react';
import "./MailPreview.css";
import UserAvatar from "../../../Controls/UserAvatar.mjs";
import DateLabel from "../../../Controls/DateLabel.mjs";
import TextLabel from "../../../Controls/TextLabel.mjs";
import appLib from "../../../libs/appLib.mjs";
import {Button, ButtonGroup} from "reactstrap";
import ReplyIcon from "../../../media/images/ReplyIcon.mjs";
import ReplyAllIcon from "../../../media/images/ReplyAllIcon.mjs";
import ForwardIcon from "../../../media/images/ForwardIcon.mjs";
import CloseIcon from "../../../media/images/CloseIcon.mjs";
import UnreadIcon from "../../../media/images/UnreadIcon.mjs";
import ReadIcon from "../../../media/images/ReadIcon.mjs";
import AttachIcon from "../../../media/images/AttachIcon.mjs";

const G = window.glob;

const Attach = class extends React.Component {
	render() {
		return(
			<div
				className="previewAttach"
				onClick={ () =>{ appLib.downloadAttach( this.props.attachment?.id ) }}
			>
				<AttachIcon />
				<span>
					{ this.props.attachment?.name }
				</span>
			</div>
		)
	}
}

const MailPreview = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
		this.setRead = this.setRead.bind(this);
		this.setUnread = this.setUnread.bind(this);
		this.uid = G.generateUid('MailPreview');
	}
	componentDidMount() {
		G.register('MessagePreview', o => {
			if ( o?.box !== this.props.box ) return;
			if ( ! o.message?.id || ! this.state.message?.id )
				return this.setState({message:o.message, read:o.read});
			if ( this.state.message?.id === o.message.id )
				return this.setState({message: {}} );
			this.setState({message: {}},()=>{
				setTimeout( ()=>{ this.setState({message:o.message, read:o.read}) }, 100);
			});
		}, this.uid );
		G.register('PlayerStatus', ps => {
			const id = this.state?.message?.id;
			if ( ! id ) return;
			const rm = ps?.read?.mail || {};
			if ( rm[id] ) {
				this.setState({ read: rm[id] });
			}
		}, this.uid);
	}
	componentWillUnmount() {
		G.deregister(this.uid );
	}
	setUnread() {
		if ( this.timeout ) {
			try { window.clearTimeout(this.timeout ) } catch (e) { }
			delete this.timeout;
		}
		const id = this.state.message?.id;
		if ( ! id ) return;
		appLib.setMailUnread(id).then( ()=>{
			this.setState( { read: false } );
			this.timeout = window.setTimeout( () => {
				this.setRead(id, true);
			}, 10000 );

		});
	}
	setRead(id, timedOut) {
		if ( this.timeout ) {
			try { window.clearTimeout(this.timeout ) } catch (e) { }
			delete this.timeout;
		}
		if ( typeof id === "undefined") {
			return;
		}
		if ( this.state.message?.id === id ) {
			if ( timedOut ) {
				if ( this.state.message?.id === id ) appLib.setMailRead(id);
			} else {
				this.timeout = window.setTimeout( () => {
					this.setRead(id, true);
				}, 3000 );
			}
		}
	}
	render() {
		const m = this.state.message;
		if ( ! m?.id ) {
			window.setTimeout( ()=>{ this.setRead(); });
			return ( <div className={"MailPreview minimized"} id={this.uid} /> );
		}
		const name = appLib.role2player(m.from);
		const mine = (m.player === G.getStatus('Player')?.id) && (this.props.box === 'sent');
		if ( ! mine && typeof this.state.read === 'undefined' ) window.setTimeout( ()=>{ this.setRead(m.id); });
		const qtrecipients = ( m.to ? m.to.length : 0 ) + ( m.cc ? m.cc.length : 0 ) + ( m.bcc ? m.bcc.length : 0 );
		return (
			<div className={"MailPreview message"} id={this.uid}>
				<div className={"header"}>
					<div className={"elements"}>
						<div className={"usericon"}>
							<UserAvatar name={name}/>
						</div>
						<div className={"info"}>
							<div className={"date"}>
								<DateLabel value={m.time}/>
							</div>
							{ m.external && (
								<div className={"people external"}>
									<em>
										<TextLabel value={"External"}/>:
									</em>
									<b>
										{ m.external }
									</b>
								</div>
							)}
							<div className={"people from"}>
								<em>
									<TextLabel value={"From"}/>:
								</em>
								<b>
									{name}
								</b>
							</div>
							<div className={"people to"}>
								<em>
									<TextLabel value={"To"}/>:
								</em>
								<b>
									{m.to.map(t => appLib.role2player(t)).join(', ')}
								</b>
							</div>
							{ m.cc && !! m.cc.length && (
								<div className={"people cc"}>
									<em>
										<TextLabel value={"CC"}/>:
									</em>
									<b>
										{m.cc.map(t => appLib.role2player(t)).join(', ')}
									</b>
								</div>
							)}
						</div>
						<div className={"controls"}>
							<Button
								className={"btn-icon"}
								onClick={(e) => {
									e.preventDefault();
									G.trigger('MessagePreview', {box: this.props.box})
								}}
							>
								<b>
									<TextLabel value={"Close"}/>
								</b>
								<i>
									<CloseIcon/>
								</i>
							</Button>
							<Button
								className={"btn-icon"}
								disabled={ ! this.state.read }
								hidden={ mine }
								color={"primary"}
								onClick={(e) => {
									e.preventDefault();
									this.setUnread();
								}}
							>
								<i>
									{ this.state.read ? <UnreadIcon/> : <ReadIcon /> }
								</i>
								<b>
									<TextLabel value={"Unread"}/>
								</b>
							</Button>
							{ appLib.userCanSendMail() && (
								<ButtonGroup>
									<Button
										title={G.label('Reply')}
										className={"btn-icon"}
										color={"success"}
										disabled={ mine }
										onClick={(e) => {
											e.preventDefault();
											G.trigger('WriteNewMail', appLib.reply(m) );
										}}
									>
										<i>
											<ReplyIcon />
										</i>
									</Button>
									<Button
										title={G.label('Reply All')}
										className={"btn-icon"}
										color={"secondary"}
										disabled={ mine && ( qtrecipients < 2 )}
										onClick={(e) => {
											e.preventDefault();
											G.trigger('WriteNewMail', appLib.reply(m, true) );
										}}
									>
										<i>
											<ReplyAllIcon/>
										</i>
									</Button>
									<Button
										title={G.label('Forward')}
										className={"btn-icon"}
										color={"warning"}
										onClick={(e) => {
											e.preventDefault();
											G.trigger('WriteNewMail', appLib.forward(m) );
										}}
									>
										<i>
											<ForwardIcon/>
										</i>
									</Button>
								</ButtonGroup>
							)}
						</div>
					</div>
					<div className={"subject"}>
						{m.subject}
					</div>
					{ m.attachments && m.attachments.length && (
						<div className={"attachments"}>
							{ m.attachments.map( (attachment, index) =>(
							<Attach
								key={index}
								attachment={attachment}
							/>
							))}
						</div>
					)}
				</div>
				<div className="body" dangerouslySetInnerHTML={{__html: m.body}}/>
			</div>
		)
	}
}

export default MailPreview;